import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { PartnerOrganizationAddress } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<PartnerOrganizationAddress>();

export class PartnerOrganizationAddressFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<PartnerOrganizationAddress>
  >((filters) =>
    filterWithRelationsAndJson(PartnerOrganizationAddress)(filters),
  );
}
